import { ArrowRight, Loader2, Sparkles } from "lucide-react";
import { Button } from "@/modern/components/ui/button-shadcn";
import { cn } from "@/modern/utils";
import { useContextViewStep } from "../context/useContextViewState";
import { WIZARD_STEP_DISPLAY } from "./wizard/wizardStepDisplay";

interface ContextWizardStateBannerProps {
  contextId: number;
  onContinueInDialog?: () => void;
}

export const ContextWizardStateBanner = ({
  contextId,
  onContinueInDialog,
}: ContextWizardStateBannerProps) => {
  const viewStep = useContextViewStep(contextId);

  if (!viewStep || viewStep === "context-view") return null;

  const { message, ctaLabel, loading = false } = WIZARD_STEP_DISPLAY[viewStep];
  const showCta = !loading && ctaLabel != null && onContinueInDialog != null;

  return (
    <div
      role="status"
      aria-live="polite"
      className={cn(
        "shrink-0 flex items-center justify-between gap-3 px-4 py-3",
        "border-b border-primary/30 bg-primary/[0.1]",
        "border-l-[3px] border-l-primary"
      )}
    >
      <div className="flex min-w-0 items-center gap-2.5">
        {loading ? (
          <Loader2 className="h-4 w-4 shrink-0 animate-spin text-primary" aria-hidden />
        ) : (
          <Sparkles className="h-4 w-4 shrink-0 text-primary" aria-hidden />
        )}
        <p
          className={cn(
            "text-sm leading-snug",
            loading ? "text-muted-foreground" : "font-medium text-foreground"
          )}
        >
          {message}
        </p>
      </div>
      {showCta && (
        <Button
          size="sm"
          onClick={onContinueInDialog}
          className="h-8 shrink-0 gap-1.5 px-3 text-xs font-semibold shadow-sm"
        >
          {ctaLabel}
          <ArrowRight className="h-3.5 w-3.5" aria-hidden />
        </Button>
      )}
    </div>
  );
};
